import React from 'react';
import styled from 'styled-components';
import { TrevorComponent } from '../../../types';
import { useDropdown } from '../DropdownHooks';

export type TriggerProps = {
  onClick?: () => void;
  stopPropagation?: boolean;
  shouldToggleOnClick?: boolean;
};

const TriggerRaw: TrevorComponent<TriggerProps, React.ReactNode> = ({
  children,
  onClick,
  stopPropagation = false,
  shouldToggleOnClick = true,
  className,
}) => {
  const { toggle, triggerRef } = useDropdown();

  const handleClick = (e: React.MouseEvent) => {
    if (stopPropagation) {
      e.stopPropagation();
    }

    if (shouldToggleOnClick) {
      toggle();
    }

    onClick?.();
  };

  return (
    <div onClick={handleClick} ref={triggerRef} className={className}>
      {children}
    </div>
  );
};

export const Trigger = styled(TriggerRaw)`
  width: fit-content;
`;
